import React from 'react';
import { IOldIconProps } from './type';

const Lock: React.FC<IOldIconProps> = ({
  width = 32,
  height = 32,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 17.3C5 14.9068 6.89418 12.9667 9.23077 12.9667H22.7692C25.1058 12.9667 27 14.9068 27 17.3V24.6667C27 27.0599 25.1058 29 22.7692 29H9.23077C6.89418 29 5 27.0599 5 24.6667V17.3Z"
      fill="#3C71DA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7692 14.05H9.23077C7.47833 14.05 6.05769 15.5051 6.05769 17.3V24.6667C6.05769 26.4616 7.47833 27.9167 9.23077 27.9167H22.7692C24.5217 27.9167 25.9423 26.4616 25.9423 24.6667V17.3C25.9423 15.5051 24.5217 14.05 22.7692 14.05ZM9.23077 12.9667C6.89418 12.9667 5 14.9068 5 17.3V24.6667C5 27.0599 6.89418 29 9.23077 29H22.7692C25.1058 29 27 27.0599 27 24.6667V17.3C27 14.9068 25.1058 12.9667 22.7692 12.9667H9.23077Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4199 20.7129C17.1514 20.5216 17.6923 19.8422 17.6923 19.0333C17.6923 18.076 16.9346 17.3 16 17.3C15.0654 17.3 14.3077 18.076 14.3077 19.0333C14.3077 19.8422 14.8486 20.5216 15.5801 20.7129C15.578 20.7305 15.5769 20.7485 15.5769 20.7667V24.2333C15.5769 24.4727 15.7663 24.6667 16 24.6667C16.2337 24.6667 16.4231 24.4727 16.4231 24.2333V20.7667C16.4231 20.7485 16.422 20.7305 16.4199 20.7129Z"
      fill="#E2E2E2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3443 20.6318C14.7353 20.3694 14.3077 19.7525 14.3077 19.0333C14.3077 18.076 15.0654 17.3 16 17.3C16.9346 17.3 17.6923 18.076 17.6923 19.0333C17.6923 19.7525 17.2647 20.3694 16.6557 20.6318C16.5798 20.6645 16.501 20.6917 16.4199 20.7129C16.422 20.7305 16.4231 20.7485 16.4231 20.7667V24.2333C16.4231 24.4727 16.2337 24.6667 16 24.6667C15.7663 24.6667 15.5769 24.4727 15.5769 24.2333V20.7667C15.5769 20.7485 15.578 20.7305 15.5801 20.7129C15.499 20.6917 15.4202 20.6645 15.3443 20.6318ZM14.5192 21.4069C13.7562 20.9066 13.25 20.0313 13.25 19.0333C13.25 17.4777 14.4812 16.2167 16 16.2167C17.5188 16.2167 18.75 17.4777 18.75 19.0333C18.75 20.0313 18.2438 20.9066 17.4808 21.4069V24.2333C17.4808 25.071 16.8178 25.75 16 25.75C15.1822 25.75 14.5192 25.071 14.5192 24.2333V21.4069Z"
      fill="black"
    />
    <path
      d="M10.9164 5.4487C9.59699 8.16086 10.2275 13.8333 10.2275 13.8333H13.4587C13.4587 13.8333 12.9851 9.33393 13.8896 7.10289C14.3204 6.04019 17.767 6.04019 18.1979 7.10289C19.1023 9.33393 18.6287 13.8333 18.6287 13.8333H21.7456C21.7456 13.8333 22.3821 8.42392 21.2443 5.4487C20.1066 2.47347 12.6398 1.90636 10.9164 5.4487Z"
      fill="#E2E2E2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6287 13.8333C18.6287 13.8333 18.6736 13.4062 18.7094 12.75C18.7897 11.2762 18.8237 8.64657 18.1979 7.10289C17.767 6.04019 14.3204 6.04019 13.8896 7.10289C13.2637 8.64657 13.2977 11.2762 13.378 12.75C13.4138 13.4062 13.4587 13.8333 13.4587 13.8333H10.2275C10.2275 13.8333 9.59699 8.16086 10.9164 5.4487C12.6398 1.90636 20.1066 2.47347 21.2443 5.4487C22.3821 8.42392 21.7456 13.8333 21.7456 13.8333H18.6287ZM19.7687 12.75H20.7807C20.8187 12.2242 20.8564 11.5234 20.864 10.7458C20.8807 9.03684 20.7485 7.12265 20.2595 5.84379C20.1141 5.46343 19.7082 5.03494 18.9524 4.68027C18.2147 4.33409 17.2636 4.11918 16.2671 4.08742C15.2709 4.05567 14.2919 4.20894 13.4944 4.53992C12.6975 4.87065 12.147 5.34822 11.8631 5.93185C11.3235 7.04106 11.1421 8.90769 11.1349 10.6627C11.1315 11.4683 11.1642 12.2021 11.1995 12.75H12.3187C12.2971 12.3378 12.2793 11.8433 12.2773 11.309C12.2719 9.90252 12.3712 8.02315 12.9127 6.68744C13.2038 5.96951 13.8854 5.63525 14.3505 5.47702C14.8746 5.29869 15.4771 5.22253 16.0437 5.22253C16.6103 5.22253 17.2128 5.29869 17.7369 5.47702C18.202 5.63525 18.8836 5.96951 19.1747 6.68744C19.7162 8.02315 19.8155 9.90252 19.8101 11.309C19.8081 11.8433 19.7903 12.3378 19.7687 12.75Z"
      fill="black"
    />
  </svg>
);

export default Lock;
